import React, { PureComponent } from 'react';
import debounce from 'debounce';
import ViewportContext from './ViewportContext';

class Viewport extends PureComponent {
  public readonly state = {
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight
  };

  public componentDidMount() {
    window.addEventListener('resize', this.handleWindowResizeDebounced);
    window.addEventListener(
      'orientationchange',
      this.handleWindowResizeDebounced
    );
    this.handleWindowResize();
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResizeDebounced);
    window.removeEventListener(
      'orientationchange',
      this.handleWindowResizeDebounced
    );
    if (
      this.handleWindowResizeDebounced &&
      this.handleWindowResizeDebounced.cancel
    ) {
      this.handleWindowResizeDebounced.cancel();
    }
  }

  public handleWindowResize = () => {
    this.setState({
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight
    });
  };

  public handleWindowResizeDebounced = debounce(this.handleWindowResize, 401);

  public render() {
    const { children } = this.props;
    return (
      <ViewportContext.Provider value={this.state}>
        {children}
      </ViewportContext.Provider>
    );
  }
}

export default Viewport;
